import { SpreadsheetConfig } from 'components/ScalarSpreadsheet/utilities/SpreadsheetConfig';
import getRowConfig from './data/getRowConfig';
import parser from './utilities/parser';
import reverseParser from './utilities/reverseParser';
import { SSV_TABLE_NAMES } from '../../constants';

const createCapTableSelectionConfig = ({ approach, ssvAttributes, capTableList, isDisabled }) => {
  const contentColumns = [[], approach.valuations_approach_ssv];

  const name = SSV_TABLE_NAMES.CAP_TABLE_SELECTION;

  return new SpreadsheetConfig({
    columns: contentColumns,
    rowConfig: getRowConfig({ capTableList, isDisabled }),
    tableData: { isDisabled },
    parser,
    name,
    initialObj: approach,
    reverseParser,
    allowConfirmAndDeleteColumn: false,
    allowDeleteColumn: false,
    handleDeleteColumn: false,
    fieldAttributes: ssvAttributes,
    showTitlesColumn: false,
    displayRowIndicator: false,
    displayColumnIndicator: false,
  });
};

export default createCapTableSelectionConfig;
